<template>
  <div class="loading darker">Loading...</div>
</template>

<script></script>
